export default __webpack_public_path__ + "static/media/Series-8600-8700-MP-Inline.7a6f3d99.png";